import * as headings from './site';

export const CUSTOM_MESSAGES = {
    ...headings,
};
